import React from 'react';
import { Input } from '../../../../shared/components/Input';
import { Select } from '../../../../shared/components/Select';
import { SectionProps } from '../../types';

const PAYMENT_TERMS_OPTIONS = [
  { value: 'net30', label: 'Net 30 Days' },
  { value: 'net45', label: 'Net 45 Days' },
  { value: 'net60', label: 'Net 60 Days' },
  { value: 'net90', label: 'Net 90 Days' },
  { value: 'immediate', label: 'Immediate' },
];

export const DetailsSection: React.FC<SectionProps> = ({ formData, onChange }) => {
  return (
    <div className="space-y-6">
      <div className="bg-white rounded-xl shadow-sm p-6">
        <h3 className="text-lg font-medium font-heading text-blueprint-blue mb-6">Project Details</h3>
        <div className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-text-grey mb-2">
              Project Description
            </label>
            <textarea
              name="description"
              value={formData.description}
              onChange={onChange}
              rows={6}
              className="w-full px-3 py-2 border border-[#E2E5EA] rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent resize-none"
              placeholder="Enter proposal description"
              required
            />
          </div>
        </div>
      </div>
      
      <div className="bg-white rounded-xl shadow-sm p-6">
        <h3 className="text-lg font-medium font-heading text-blueprint-blue mb-6">Payment & Validity</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Payment Terms */}
          <div>
            <Select
              label="Payment Terms"
              value={formData.paymentTerms}
              options={PAYMENT_TERMS_OPTIONS}
              placeholder="Select payment terms"
              onChange={(value) => onChange({ target: { name: 'paymentTerms', value } } as React.ChangeEvent<HTMLSelectElement>)}
            />
          </div>

          {/* Validity Period */}
          <div>
            <label className="block text-sm font-medium text-text-grey mb-2">
              Validity Period
            </label>
            <div className="relative">
              <Input
                type="number"
                name="validityPeriod"
                value={formData.validityPeriod}
                onChange={onChange}
                className="pr-12"
                placeholder="Enter days"
              />
              <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                <span className="text-heritage-grey sm:text-sm">days</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}; 